<template>
  <v-container>
    <resource-details
      v-if="selectedResource"
      :resource="selectedResource"
      @addResourceToPage="addResourceToPage"
      @openFullModal="setResourceViewer({ show: true, resourceId: $event })"
      @back="
        selectedResource = false;
        focus = null;
      "
    ></resource-details>
    <template v-else>
      <v-layout column class="">
        <v-card-title class="pt-0 shrink">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <div class="flex-grow-1"></div>
          <v-switch
            class="pt-3"
            v-model="searchExcerpts"
            label="Search Excerpts"
            color="primary"
          ></v-switch>
          <!-- <v-select
              v-model="sortBy"
              hide-details
              :items="keys"
              prepend-inner-icon="sort"
              label="Sort by"
            ></v-select> -->
        </v-card-title>
        <v-data-iterator
          class=""
          style="overflow-y: auto;"
          :items="items"
          :items-per-page="10"
          :search="search"
          :page="page"
          :custom-filter="filterItems"
          :sort-by="sortBy.toLowerCase()"
          :sort-desc="false"
        >
          <template v-slot:default="props">
            <template v-for="item in props.items">
              <div class="pa-2" :key="item.id">
                <resource-card
                  variant="listItem"
                  :blockData="{ resource: item }"
                  blockType="block"
                  @clicked="selectResource(item)"
                ></resource-card>
              </div>
              <div class="pa-2" v-for="excerpt in filteredExcerpts[item.id]" :key="excerpt.id">
                <resource-card
                  variant="hide-image"
                  :blockData="{ resource: item, excerpts: [excerpt], highlight: search }"
                  blockType="excerpt"
                  @clicked="selectResource(item, excerpt.id)"
                >
                  <template v-if="userCanEdit" v-slot="props">
                    <v-tooltip right open-delay="200" transition="fade" v-if="props.hover">
                      <template v-slot:activator="{ on }">
                        <v-fade-transition>
                          <v-btn
                            outlined
                            icon
                            x-small
                            style="position: absolute; left: -8px; background: white;"
                            v-on="on"
                            @click.stop="
                              addResourceToPage({ excerptId: excerpt.id, resource: item })
                            "
                          >
                            <v-icon small>add</v-icon>
                          </v-btn>
                        </v-fade-transition>
                      </template>
                      <span>Add excerpt to notebook</span>
                    </v-tooltip>
                  </template>
                </resource-card>
              </div>
            </template>
          </template>
        </v-data-iterator>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

import ResourceDetails from './ResourceDetails';
import ResourceCard from '@/components/Resources/ResourceCard';
export default {
  components: {
    ResourceDetails,
    ResourceCard
  },
  props: ['value', 'order', 'widget'],
  data() {
    return {
      mini: true,
      search: null,
      c: console,
      searchExcerpts: false,
      focusExcerpt: null,
      itemExcerpts: {},
      iconExists: true,
      itemsPerPageArray: [4, 8, 12],
      page: 1,
      itemsPerPage: 4,
      sortBy: 'name',
      filteredExcerpts: {},
      selectedResource: false
    };
  },
  computed: {
    ...mapState('resources', ['resources']),
    ...mapState('views/context', ['showResourcePanel', 'selectedPageId']),
    ...mapGetters('context', ['userCanEdit', 'userIsWorkspaceMember', 'context']),
    items() {
      return Object.values(this.resources).filter(r => !!r.usedOn[this.context.id]);
    },
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    }
  },
  methods: {
    ...mapMutations('views/context', ['setResourceViewer']),
    ...mapActions('pages', ['addNoteBlock']),
    selectResource(resource, excerptId) {
      if (excerptId) {
        this.focusExcerpt = excerptId;
      } else {
        this.focusExcerpt = null;
      }
      this.selectedResource = resource;
    },
    filterItems(items, search) {
      this.filteredExcerpts = {};
      if (search == null) return items;
      const filtered = [];
      items.forEach(item => {
        try {
          const i = item; // make a clone
          const { title, description, provider } = i.resourceData;
          const tags = i.tags.userDefined;
          const tagString = Object.values(tags)
            .map(t => t.text)
            .toString();
          const searchableString = `${title ? title : ''} ${description ? description : ''} 
          ${provider ? provider : ''} ${tagString}`;
          let found = false;
          if (searchableString.toLowerCase().includes(search.toLowerCase())) {
            filtered.push(i);
            found = true;
          }
          if (this.searchExcerpts && search.length > 1) {
            this.filteredExcerpts[i.id] = [];
            const excerpts = Object.values(i.noteBlocks).filter(
              n => n.content.widgetType == 'textExcerpt' && !n.toDelete
            );
            excerpts.forEach(e => {
              if (e.content.widgetData.excerpt.toLowerCase().includes(search.toLowerCase())) {
                if (!found) {
                  filtered.push(i);
                  found = true;
                }
                this.filteredExcerpts[i.id].push(e);
              }
            });
          } else {
            this.fitleredExcerpts = {};
          }
        } catch (e) {
          console.log(e);
        }
      });
      return filtered;
      // search = search.toString().toLowerCase();
      // return items.filter(i => Object.keys(i).some(j => filter(i[j], search)));
    },
    addResourceToPage({ excerptId, resource }) {
      const resourceData = {
        pageId: this.selectedPageId,
        html: false,
        widgetInfo: {
          widgetType: 'resource',
          widgetData: {
            resourceId: resource.id,
            resourceVersion: resource.version,
            resourceNoteIds: excerptId ? [excerptId] : []
          }
        }
      };
      this.$emit('addResourceToPage', resourceData);
    }
  }
};
</script>

<style></style>
